import React from "react";
import { CheckIcon } from "lucide-react";
import { system } from "../data/content";
import { surface } from "../data/theme";
import { Reveal } from "./Reveal";
import { Section } from "./Section";
import { SectionTitle } from "./SectionTitle";
export function SystemOverview() {
  return <Section labelledBy="system-title" className="bg-navy-dots text-center" waveTo={surface.white} data-id="element-199" data-mp="1hnuilub2qf2c">
      <Reveal data-id="element-200" data-mp="txqc9f6i417n">
        <SectionTitle id="system-title" tone="dark" title={system.title} highlight={system.highlight} data-id="element-201" data-mp="tx8ak312kusc" />
        <p className="mt-6 text-lg font-bold text-white" data-id="element-202" data-mp="px6ec9e3stkg">{system.name}</p>
        <p className="mt-2 text-sm font-semibold text-gold" data-id="element-203" data-mp="13vwgi3fs5jfo">{system.verbs}</p>
      </Reveal>

      <ul className="mx-auto mt-8 grid max-w-xl gap-2.5 text-left sm:grid-cols-2" data-id="element-204" data-mp="yx330b0htsfi">
        {system.items.map((item, i) => <Reveal as="li" key={item} delay={i * 0.04} className="flex items-center gap-3 rounded-xl bg-white/[0.06] px-4 py-3.5 font-medium leading-snug text-white ring-1 ring-white/10" data-id="element-205" data-mp="2fatgg8di5t1t" data-mpi={i}>
            <span className="bg-gold-gradient flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-navy" data-id="element-206" data-mp="236mhak9zf8ys">
              <CheckIcon className="h-3.5 w-3.5" strokeWidth={3.5} aria-hidden="true" data-id="element-207" data-mp="284nzz43hx69q" />
            </span>
            {item}
          </Reveal>)}
      </ul>
    </Section>;
}